export const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div 
                style={{
                    background: "#FFFFFF",
                    padding: "4px",
                    border: "1px solid #5676D4",
                }}
            >
                {`${payload[0].name}`}
            </div>
        );
    }
    return null;
};

export default CustomTooltip;